import { CSSObject } from '@emotion/react'
import { fontWeights, fonts, fontSizes } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'
import { mediaControlsAtTop } from '../../../../helpers/styles'
import { sharedColors } from '../../../sharedDisplays/sharedStyles'
import { postHeight, postWidth } from '../../styles'

const inputStyles: CSSObject = {
  alignItems: 'center',
  backgroundColor: 'transparent',
  color: 'white',
  fontSize: fontSizes.medium,
  display: 'block',
  letterSpacing: '0.1px',
  lineHeight: '16px',
  boxSizing: 'border-box',
  fontFamily: fonts['helvetica'],
}

export const getOverlayStyles = (truncate: boolean): CSSObject => ({
  color: colors.white.base,
  width: '100%',
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  zIndex: truncate ? 1 : 1001,
  fontFamily: fonts['helvetica'],
})

const overlayHeaderStyles: CSSObject = {
  background: 'linear-gradient(-180deg, rgba(0,0,0,0.5), rgba(0,0,0,0) 100%)',
  display: 'flex',
  pointerEvents: 'auto',
  fontSize: '24px',
  fontWeight: fontWeights.bold,
  justifyContent: 'space-between',
  paddingLeft: '25px',
  paddingRight: '18px',
  paddingTop: '18px',
}

const titleStyles: CSSObject = {
  letterSpacing: '0.17px',
}

const statsAndMessagesStyles: CSSObject = {
  alignItems: 'flex-end',
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 'auto',
  marginTop: '307px',
  paddingRight: '17px',
  position: 'relative',
  top: 50,
  zIndex: 99,
  'span:nth-of-type(2n-1)': {
    marginBottom: '8px',
  },
  'span:nth-of-type(2)': {
    marginBottom: '20px',
  },
  'span:nth-of-type(4)': {
    marginBottom: '22px',
  },
  'span:nth-of-type(5)': {
    marginBottom: '24px',
  },
  'span:nth-of-type(6)': {
    marginBottom: '0px',
    marginRight: '6px',
  },
}

const numberTextStyles: CSSObject = {
  fontSize: fontSizes.xSmall,
  letterSpacing: '0.09px',
  marginRight: '3px',
}

const accountStyles: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  color: colors.orange.base,
  paddingBottom: '6px',
  paddingTop: '27px',
}

const getFooterStyles = (readOnly: boolean): CSSObject => ({
  position: 'absolute',
  bottom: '0px',
  paddingLeft: '25px',
  width: postWidth,
  boxSizing: 'border-box',
  pointerEvents: readOnly ? 'none' : 'auto',
  cursor: readOnly ? 'pointer' : 'default',
  background: 'linear-gradient(-180deg, rgba(0,0,0,0), rgba(0,0,0,0.5) 100%)',
})

const followButtonStyles: CSSObject = {
  alignItems: 'center',
  border: '1px solid rgba(255, 255, 255, 0.3)',
  display: 'inline-flex',
  height: '24px',
  borderRadius: '3px',
  marginLeft: '14px',
  width: '59px',
  div: {
    color: colors.white.base,
    fontSize: fontSizes.medium,
    letterSpacing: '0.1px',
    margin: 'auto',
  },
}

const musicArtStyles: CSSObject = {
  marginLeft: '19px',
  paddingTop: '2px',
}

const musicContainerStyles: CSSObject = {
  display: 'inline-flex',
  marginBottom: '14px',
  marginTop: '5px',
}

const captionContainerStyles: CSSObject = {
  marginLeft: '-4px',
}

const captionPlaceholderStyles: CSSObject = {
  color: `${colors.white.base} !important`,
}

const captionDivStyles: CSSObject = {
  whiteSpace: 'pre-wrap',
  overflow: 'scroll',
  maxHeight: '304px',
}

const accountNameWrapperStyles: CSSObject = {
  marginLeft: '8px',
  fontSize: fontSizes.medium,
  color: colors.white.base,
  maxWidth: '240px',
}

const accountNameStyles: CSSObject = {
  fontWeight: fontWeights.bold,
  fontFamily: fonts.helvetica,
  display: 'inline',
}

const effectContainerStyles: CSSObject = {
  background: 'rgba(0,0,0,0.6)',
  borderRadius: '12px',
  height: '24px',
  paddingRight: '18px',
  paddingLeft: '12px',
  display: 'inline-block',
  marginBottom: '15px',
}

const effectTextStyles: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'space-around',
  '.kuiper-icon-wrapper': {
    paddingRight: '4px',
  },
  span: {
    fontFamily: fonts.proxima,
    fontSize: fontSizes.xxSmall,
    fontWeight: fontWeights.bold,
    lineHeight: '13px',
  },
}

const musicIconPadding: CSSObject = {
  padding: '7px 4px 0 0',
}

export const getMusicInputStyles = (
  truncate: boolean,
  readOnly: boolean
): CSSObject => ({
  height: '26px',
  input: {
    ...inputStyles,
    border: 'none',
    width: '272px',
    padding: '5px',
    borderRadius: '3px',
    '&::placeholder': {
      color: 'white',
    },
    '&:hover': {
      background:
        truncate || readOnly
          ? 'transparent'
          : (sharedColors.semiOpaqueGrey as string),
    },
    '&:active, &:focus': {
      border: 'none',
      outline: 'none',
    },
  },
})
const collabAvatarStyles: CSSObject = {
  height: '34px',
  width: '34px',
  div: {
    display: 'block',
  },
  'div:nth-of-type(2)': {
    marginLeft: '10px',
    marginTop: '-14px',
    display: 'block',
  },
}

export const getAssetStyles = (): CSSObject => ({
  height: postHeight.mobileSingle,
  backgroundColor: '#000',
  img: {
    borderRadius: '2px',
  },
  video: {
    borderRadius: '2px',
    height: postHeight.mobileSingle,
    width: postWidth,
  },
})

export const getAssetBaseStyles = (
  showDescription: boolean,
  footerHeight: number,
  truncate?: boolean
): CSSObject => ({
  ...mediaControlsAtTop,
  display: 'flex',
  height: postHeight.mobileSingle,
  alignItems: 'center',
  opacity: showDescription ? '0.2' : '1',
  borderRadius: '2px',

  '.kuiper-asset-info-wrapper': {
    marginBottom: footerHeight < 240 || truncate ? 0 : 120,
  },
})

export const getCaptionStyles = (
  truncate: boolean,
  readOnly: boolean
): CSSObject => ({
  ...inputStyles,
  width: '292px',
  '&:hover': {
    background:
      truncate || readOnly
        ? 'transparent'
        : (sharedColors.semiOpaqueGrey as string),
  },
})

export const getInfoOverlayStyles = (
  footerHeight: number,
  assetHeight: number
): CSSObject => ({
  // overlay should be in between header and footer. Header height is 90, post height is 729
  height: `${Math.min(729 - 90 - footerHeight, assetHeight)}px`,
})

export const styles = {
  accountNameWrapperStyles,
  accountNameStyles,
  accountStyles,
  captionContainerStyles,
  captionPlaceholderStyles,
  captionDivStyles,
  effectContainerStyles,
  effectTextStyles,
  collabAvatarStyles,
  followButtonStyles,
  getFooterStyles,
  musicArtStyles,
  musicContainerStyles,
  musicIconPadding,
  numberTextStyles,
  overlayHeaderStyles,
  statsAndMessagesStyles,
  titleStyles,
}
